import { IStationAlarm } from "modules/common/components/Alarms/types/AlarmModels";
import { County, Phenophase } from "services/iot/models";

export type FormValues = {
    name: string;
    statinonMeasurementAlarms: IStationAlarm[];
    crop: string;
    phenophase?: { name?: string | null; id: number };
};

export enum StationType {
    Pinova,
    Metos,
}

export type Station = {
    name: string;
    id: number;
    zupanija: County;
    type: StationType;
};

export interface ValueRange<T> {
    min?: T;
    max?: T;
}

export interface IInitialValuesBase {
    name: string;
    crop: string;
    phenophase?: Phenophase;
    airTempMin?: number;
    airTempMax?: number;
    humidityMin?: number;
    humidityMax?: number;
    windMin?: number;
    windMax?: number;
    rainAmount?: number;
    rainDays?: number;
    pestsCount?: number;
    pestsDays?: number;
}
